import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa111720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "justify-between items-center" }
const _hoisted_2 = { class: "mb-10 flex justify-center" }
const _hoisted_3 = { class: "items-stretch" }
const _hoisted_4 = {
  key: 0,
  class: "justify-center items-center align-center locked"
}
const _hoisted_5 = { class: "items-stretch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
          (_ctx.toWalletNFTs && _ctx.toWalletNFTs.length) ||
          (_ctx.toVaultNFTs && _ctx.toVaultNFTs.length)
        )
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rounded bg-dark py-2 px-4 mr-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveNFTsOnChain && _ctx.moveNFTsOnChain(...args)))
          }, " Move Residents "))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Your vault",
            class: "flex-1",
            nfts: _ctx.desiredVaultNFTs,
            onSelected: _ctx.handleVaultSelected
          }, {
            default: _withCtx(() => [
              (_ctx.vaultLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["nfts", "onSelected"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_NFTGrid, {
        title: "Your wallet",
        class: "flex-1",
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, null, 8, ["nfts", "onSelected"])
    ])
  ]))
}